import React from 'react'
import { Flex, Grid, NewCard } from '@fareye/ui'
import { SideBarListing } from '../../style/styled'
import { mapComponent } from '../../utility/constants'
import queryString from 'query-string'
import TrackingDetail from './components/TrackingDetail'
import { useTranslation } from '@fareye/common'
const style: any = {
  tripTabs: {
    marginTop: '6px',
    boxShadow: '0 4px 14px 0 rgba(0,0,0,0.1)',
    backgroundColor: '#FFFFFF'
  }
}

const ParcelLayout = ({ data, config, location, match, baseUrl }: any) => {
  const { t } = useTranslation()
  const {
    config: { tabsComponent }
  } = config

  const { tab = '' } = queryString.parse(location.search)
  const [sideBarTab, setSideBarTab] = React.useState<any>(
    tab ? tab : 'summaryParcel'
  )
  const Component = (mapComponent as any)[tabsComponent[sideBarTab].component]
  return (
    <NewCard
      style={{
        border: 'none',
        width: '100%',
        padding: '0 15px',
        boxSizing: 'border-box'
      }}
    >
      <NewCard.Header>
        <Flex style={style.tripTabs}>
          {Object.keys(tabsComponent).map((item: string) => (
            <SideBarListing
              isSelected={sideBarTab === item}
              id={item}
              onClick={() => setSideBarTab(item)}
              key={item}
            >
              {t(tabsComponent[item].label)}
            </SideBarListing>
          ))}
        </Flex>
      </NewCard.Header>
      <NewCard.Body>
        <Grid
          gridTemplateColumns={
            tabsComponent[sideBarTab].showPackageDetails ? ' 2fr 1fr' : '1fr'
          }
          gridGap="12px"
          style={{
            marginTop: '5px',
            boxSizing: 'border-box',
            overflow: 'hidden auto'
          }}
        >
          {tabsComponent[sideBarTab].showPackageDetails && (
            <Flex
              column
              style={{
                position: 'relative',
                boxSizing: 'border-box'
              }}
            >
              <TrackingDetail
                baseUrl={baseUrl}
                config={config}
                data={data}
                match={match}
              />
            </Flex>
          )}
          <div
            style={{
              boxSizing: 'border-box',
              overflow: 'hidden auto',
              background: 'white'
            }}
          >
            <Component
              data={data}
              config={tabsComponent[sideBarTab]}
              sideBarTab={sideBarTab}
              changeTab={setSideBarTab}
            />
          </div>
        </Grid>
      </NewCard.Body>
    </NewCard>
  )
}
export default ParcelLayout
